import client from "../../api/client";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetBoardRecentResponse } from "../../api/board";

export const fetchBoardsRecent = async (): Promise<GetBoardRecentResponse> => {
  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = token
    ? { headers: { Authorization: `Bearer ${token}` } }
    : { headers: { Authorization: `` } };
  return await client()
    .recent.get({ ...authHeader })
    .then((res) => {
      return {
        status_code: 200,
        message: "",
        data: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardsRecent");
      return {
        status_code: status,
        message: message,
        data: [],
      };
    });
};
